import { SiteID } from './SiteID';

/**
 * Represents a "frontend project". They map 1:1 with the directories in the `/apps` directory.
 * They posses a one-to-many relationship with site IDs, i.e. a single app can be used to build
 * multiple sites.
 */
export enum AppID {
  AHNU = 'ahnu',
  CONDUCTOR = 'conductor',
  HOKA = 'hoka',
  /** @deprecated Will be removed in HP-4549. */
  KOOLABURRA = 'koolaburra',
  /** @deprecated Will be removed in HP-4549. */
  SANUK = 'sanuk',
  TEVA = 'teva',
  UGG = 'ugg',
  UGG_COLLAB = 'ugg-collab'
}

const SITE_ID_TO_APP_ID_RECORD = {
  [SiteID.AHNU_US]: AppID.AHNU,
  [SiteID.CONDUCTOR_US]: AppID.CONDUCTOR,
  [SiteID.HOKA_US]: AppID.HOKA,
  [SiteID.KOOLABURRA]: AppID.KOOLABURRA,
  [SiteID.SANUK]: AppID.SANUK,
  [SiteID.TEVA_US]: AppID.TEVA,
  [SiteID.UGG_COLLAB_US]: AppID.UGG_COLLAB,
  [SiteID.UGG_US]: AppID.UGG
} as const satisfies Record<SiteID, AppID>;

/**
 * Gets the {@link AppID} associated with a given {@link SiteID}.
 * @param siteID - The {@link SiteID} to get the AppID for.
 * @returns The corresponding {@link AppID}.
 * @throws An error if the site ID does not correspond to a known AppID.
 */
export function siteIDToAppID(siteID: SiteID): AppID {
  const appID = SITE_ID_TO_APP_ID_RECORD[siteID];
  if (appID === undefined) {
    throw new Error(`No AppID found for SiteID: ${siteID}`);
  }
  return appID;
}
